module.exports = __webpack_public_path__ + "img/cloud_download.4d43a08f.svg";